import { IBundle } from '../../models/bundle.model';
import { EntityState, IBundleState } from '../app.state';
import { EntityReducer } from '../entity.reducer';
import { fromBundleActions } from './bundle.actions';

export const initialState = EntityState.create<IBundle, IBundleState>();
export const bundleReducer = EntityReducer.create<IBundle, IBundleState>(initialState, fromBundleActions, 'bundle');
